import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';

const Snowflakes = loadable(() => import(/* webpackChunkName: "Snowflakes" */ './Snowflakes'));

export const SnowflakesAsync = () => (
    <Suspense>
        <Snowflakes />
    </Suspense>
);
